import { render, staticRenderFns } from "./Driver.vue?vue&type=template&id=287e3ddd&scoped=true"
import script from "./Driver.vue?vue&type=script&lang=js"
export * from "./Driver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287e3ddd",
  null
  
)

export default component.exports